import { render } from "./BatchMaster.vue?vue&type=template&id=33fc0f36&scoped=true"
import script from "./BatchMaster.vue?vue&type=script&lang=js"
export * from "./BatchMaster.vue?vue&type=script&lang=js"

import "./BatchMaster.vue?vue&type=style&index=0&id=33fc0f36&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33fc0f36"]])

export default __exports__